import GenericCreateForm from "../../../../components/GenericCreateForm";

function CreateActiveCategory() {
  return (
    <GenericCreateForm
      title="Categoría de Activo"
      endpoint="/active-categories"
      backTo="/actives/categories"
    />
  );
}

export default CreateActiveCategory;
